import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataFetched: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "commandListPage",
  initialState: initialState,
  reducers: {
    getCommandListPageData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.dataFetched = false;
    },
    getCommandListPageDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.dataFetched = true;
    },
    getCommandListPageDataError: (state, action) => {
      state.error = action.payload;
      state.dataFetched = false;
      state.loading = false;
    },
    commandListPageResetState: () => initialState,
  },
});

export const {
  getCommandListPageData,
  getCommandListPageDataSuccess,
  getCommandListPageDataError,
  commandListPageResetState,
} = slice.actions;

export default slice.reducer;
